module.exports = __webpack_public_path__ + "img/drop-down.71f12dec.svg";